<template>
  <div>
    <v-textarea outlined :rules="getFieldRules()" v-model="value"></v-textarea>
  </div>
</template>

<script>
export default {
  name: 'TextArea',
  props: {
    field: {
      type: Object,
      required: true
    },
    onChange: {
      type: Function,
      default: () => ''
    },
    defaultValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      value: ''
    }
  },
  mounted() {
    this.value = this.defaultValue
  },
  watch: {
    value(val) {
      this.onChange({
        id: this.field._id,
        value: { text: val },
        rawValues: val,
        ...this.getValidationResults()
      })
    }
  },
  methods: {
    getErrMsg() {
      const rules = this.getFieldRules()
      for (const f of rules) {
        const ruleRes = f(this.value)
        if (typeof ruleRes === 'string') {
          return ruleRes
        }
      }
      return null
    },
    getValidationResults() {
      const errMsg = this.getErrMsg()
      return errMsg ? { errMsg, valid: false } : { errMsg, valid: true }
    },
    getFieldRules() {
      const rulesF = []
      if (this.field.data.required) {
        rulesF.push(value => !!value || 'Required')
      }
      if (this.field.data.attrs.hasMin) {
        rulesF.push(
          value =>
            (value && value.length >= this.field.data.attrs.min) ||
            `Min length is ${this.field.data.attrs.min}`
        )
      }
      if (this.field.data.attrs.hasMax) {
        rulesF.push(
          value =>
            (value && value.length <= this.field.data.attrs.max) ||
            `Max length is ${this.field.data.attrs.max}`
        )
      }
      return rulesF
    }
  }
}
</script>

<style lang="scss" scoped></style>
